<template>

    <div class="container-fluid">

        <div id="accordion">
            <div class="card">
                <div class="card-header" v-on:click="show = !show">
                    <div class="row px-3">
                        <div>
                            <button class="all-btn add-btn">{{$t("main.search")}} .... </button>
                        </div>
                        <div class="px-3">
                            <button class="all-btn" @click="initList">{{$t("main.search")}}
                            </button>
                        </div>
                        <div>
                            <p style="color: #18ce0f">
                                <button class="all-btn" @click.prevent="reportXslx()">
                                    {{$t("accounting.account.report")}}
                                </button>
                            </p>
                        </div>
                    </div>
                </div>

                <div v-if="show" id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row mb-3">

                            <div class="col-xl-3 col-md-4 col-sm-12 mb-2"  v-if="organizationListValue.data && organizationListValue.data.length > 0">
                                <label>{{$t("accounting.account.organization")}}</label>
                                <select class="form-control" v-model="filter.organizationType"
                                        @change="onOrganizationTypeChange">
                                    <option value="" v-if="organizationListValue.data.length === organizationListValue.total"></option>
                                    <option :value="option.code" v-for="option in organizationListValue.data"
                                            :key="option.code">
                                        {{option.displayName}}
                                    </option>
                                </select>
                            </div>

                            <div class="col-xl-3 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("accounting.account.province")}}</label>
                                <v-select v-model="filter.province" label="name"
                                          :options="provinces"
                                          :filterable="false"
                                          :disabled="regionalLeaderProvince!=null"
                                          @search="onProvinceGetRegionsChange"
                                          @change="onProvinceGetRegionsChange">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-xl-3 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("accounting.account.city")}} ва
                                    {{$t("accounting.account.district")}}</label>
                                <v-select v-model="filter.region" label="name"
                                          :options="regions"
                                          :filterable="false"
                                          @search="onRegionsChange"
                                          @change="onRegionsChange">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <label>{{$t("report.field.objectType")}}</label>
                                <select v-model="filter.objectType" class="form-control" @change="initList">
                                    <option value="AutoAndFitment" style="font-family:verdana;">Авто ва Асбоб-ускуналар</option>
                                    <option value="RealEstate">Кўчмас мулк</option>
                                </select>
                            </div>
                        </div>
                        <!--<div class="row">-->
                            <!--<div class="col-sm-2">-->
                                <!--<label>{{$t("report.field.by")}}</label>-->
                                <!--<select v-model="filter.by" class="form-control" @change="initList">-->
                                    <!--&lt;!&ndash;<option disabled value="">{{$t("messages.combo.empty")}}</option>&ndash;&gt;-->
                                    <!--<option value="CONTRACT" style="font-family:verdana;">Хизматлар</option>-->
                                    <!--<option value="PAID">Туланганлар</option>-->
                                    <!--<option value="UN_PAID">Карздорлик</option>-->
                                <!--</select>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>

                <div v-if="evaluationObjectIds.length>0" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <button class="all-btn add-btn" @click.prevent="sendRequirement()">{{$t("main.send")}}
                            </button>
                            <button style="background-color: #97181d" class="all-btn"
                                    @click.prevent="requirementPdf()">{{$t("accounting.account.requirement")}}
                            </button>

                            <div class="mt-3">
                                Мулклар: <strong>{{evaluationObjectIds}}</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="selectedEvaluationObject.length>0" id="soldoDate" class="collapse show"
                     data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="salePropertyDto.tradingDay"
                                        placeholder="Савдо куни"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-sm-2">
                                <input type="text" placeholder="Лот рақами" class="form-control"
                                       v-model="salePropertyDto.numberLot"/>
                            </div>
                            <div class="col-sm-1">
                                <button class="all-btn add-btn pull-right" @click.prevent="saveSalesDay()">
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="selectedNumberLot.length>0" id="salesDay" class="collapse show" data-parent="#accordion">
                    <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-sm-4">
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="salePropertyDto.saleDate"
                                        placeholder="Сотилган сана"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-sm-4 my-2 my-sm-0">
                                <numeric-input type="text" placeholder="Сотилган нарх" class="form-control"
                                               v-model="salePropertyDto.price"/>
                            </div>
                            <div class="col-sm-3">
                                <button class="all-btn add-btn m-0" @click.prevent="saveSalesDay()">
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body scroll-card-body table-responsive">
                        <div class="row">
                            <div class="col col-sm-6">
                                <!--<div id="chart2">-->
                                    <!--<vue-apex-charts type="bar" height="350" :options="chartOptions" :series="series"></vue-apex-charts>-->
                                <!--</div>-->

                                <!--<div id="chart">-->
                                    <!--<vue-apex-charts type="pie" :options="chartOptions"-->
                                                     <!--:series="series"></vue-apex-charts>-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <loading v-if="loading"></loading>
                                <horizontal-bar-chart ref="autoFitment"
                                                      v-show="!loading && filter.province==null"
                                                      :data="contractAmountTotal"
                                                      :title="'Авто ва Асбоб-ускуналар'"
                                                      :organizationType="filter.organizationType">
                                </horizontal-bar-chart>
                                <!--<button @click="updateChart">Update!</button>-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <loading v-if="loading"></loading>
                                <bar-chart-month ref="autoFitment2"
                                                 v-show="!loading"
                                                 :data="contractAmountTotal"
                                                 :title="'Авто ва Асбоб-ускуналар Ойлар буйича'"
                                                 :organizationType="filter.organizationType"
                                                 :province="filter.province">
                                </bar-chart-month>
                            </div>
                            <div class="col col-12" v-show="filter.province!=null">
                                <loading v-if="loading"></loading>
                                <regions-bar-chart
                                        v-show="!loading && filter.province!=null"
                                        :title="'Авто ва Асбоб-ускуналар Туманлар буйича'"
                                        :organizationType="filter.organizationType"
                                        :province="filter.province">
                                </regions-bar-chart>
                            </div>

                            <div class="col col-12">
                                <hr class="bold-row"/>
                            </div>
                            <div class="col col-12">
                                <loading v-if="loading"></loading>
                                <mixed-bar-chart ref="mixedBarChart"
                                                 :source="contractAmountTotal"
                                                 v-show="!loading"
                                                 :title="'Авто ва Асбоб-ускуналар (Ташкилотлар буйича)'">
                                </mixed-bar-chart>
                                <!--<button @click="updateChart">Update!</button>-->
                            </div>
                        </div>
                        <!--<div class="row">-->
                            <!--<div class="col col-8">-->
                                <!--<mixed-bar-month-chart ref="mixedBarChart2" :source="contractAmountTotal" :type="BUREAU_OF_COMPULSORY_EXECUTION"></mixed-bar-month-chart>-->
                                <!--&lt;!&ndash;<button @click="updateChart">Update!</button>&ndash;&gt;-->
                            <!--</div>-->
                            <!--<div class="col col-8">-->
                                <!--<mixed-bar-month-chart ref="mixedBarChart2" :source="contractAmountTotal" :type="CUSTOMS_ADMINISTRATION"></mixed-bar-month-chart>-->
                                <!--&lt;!&ndash;<button @click="updateChart">Update!</button>&ndash;&gt;-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                    <div class="text-center">
                        <div class="loader mt-5 mb-5" v-if="loading"></div>
                        <span class="no-data mt-5 mb-5"
                              v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                    </div>
                    <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                        <div class="col-12 pt-3 pb-3">
                            <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                          :per-page="filter.page.size" @change="onPageChange">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate, formatDateText, findBy} from '@/shared/utils';
    import HorizontalBarChart from '@/views/reports/chart/HorizontalBarChart';
    import BarChartMonth from '@/views/reports/chart/BarChartMonth';
    import MixedBarChart from '@/views/reports/chart/MixedBarChart';
    import RegionsBarChart from '@/views/reports/chart/RegionsBarChart';
    // import MixedBarMonthChart from '@/views/reports/chart/MixedBarMonthChart';
    // import VueApexCharts from 'vue-apexcharts'
    import Loading from '@/views/Loading';


    // export const
    export default {
        name: "IncomingChart",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            // VueApexCharts,
            HorizontalBarChart,
            BarChartMonth,
            MixedBarChart,
            RegionsBarChart,
            Loading,
            // MixedBarMonthChart
        },
        data() {
            return {
                loading: false,
                show: false,
                filter: initFilterModel(),
                results: null,
                realEstateResults: null,
                regionalLeaderProvince: null,
                resultList: [],
                contractAmountTotal: {
                    BUREAU_OF_COMPULSORY_EXECUTION: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: []
                    },
                    CUSTOMS_ADMINISTRATION: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: []
                    },
                    OTHER: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: []
                    },
                    TRAFFIC_ACCIDENTS: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: []
                    },
                    ALL: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: []
                    }
                },

                organization: this.$t("accounting.account.organization"),
                evaluationObjectIds: [],
                organizationListValue: {},
                regions: [],
                provinces: [],
                salePropertyDto: {},
                selectedEvaluationObject: [],
                selectedNumberLot: [],
                // series: [44, 55, 13, 43, 22],
                // chartOptions: {
                //     labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
                //     responsive: [{
                //         breakpoint: 480,
                //         options: {
                //             chart: {
                //                 width: 200
                //             },
                //             legend: {
                //                 position: 'bottom'
                //             }
                //         }
                //     }]
                // }

                series: [{
                    data: [0, 0, 0]
                }],
                chartOptions: {
                    plotOptions: {
                        bar: {
                            barHeight: '100%',
                            distributed: true,
                            horizontal: true,
                            dataLabels: {
                                position: 'bottom'
                            },
                        }
                    },
                    colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
                        '#f48024', '#69d2e7'
                    ],
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'start',
                        style: {
                            colors: ['#000']
                        },
                        formatter: function (val, opt) {
                            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
                        },
                        offsetX: 0,
                        dropShadow: {
                            enabled: true
                        }
                    },

                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    xaxis: {
                        categories: ['Мажбурий ижро бюроси', 'Божхона бошқармаси', 'Бошқа']
                        // categories: ['South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                        //     'United States'
                        // ],
                    },
                    yaxis: {
                        labels: {
                            show: false
                        }
                    },
                    title: {
                        text: 'ТАШКИЛОТЛАР',
                        align: 'center',
                        floating: true
                    },
                    subtitle: {
                        text: 'Category Names as DataLabels inside bars',
                        align: 'center',
                    },
                    tooltip: {
                        theme: 'dark',
                        x: {
                            show: false
                        },
                        y: {
                            title: {
                                formatter: function () {
                                    return ''
                                }
                            }
                        }
                    }
                }
            }
        },
        methods: {

            // updateChart() {
            //
            //     // In the same way, update the series option
            //     this.series = [{
            //         data: [0, 0, 0]
            //     }];
            //
            //     this.chartOptions = {
            //             xaxis: {
            //                 categories: ['Мажбурий ижро бюроси', 'Божхона бошқармаси', 'Бошқа']
            //             }
            //         };
            //
            //     // this.chartOptions.xaxis.categories= ['Italy', 'France', 'Japan', 'United States'];
            // },
            async initList() {
                this.loading = true;
                //this.init();

                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                await Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });

                const regionalLeader = vm.$store.state.profile.regionalLeader;
                if (regionalLeader){
                    const regionalLeaderProvince = regionalLeader.userProvinces[0];
                    vm.filter.province = regionalLeaderProvince;

                    this.provinces.forEach((province) => {
                        if (province.id === this.filter.province.id) {
                            vm.filter.province.regions = province.regions;
                        }
                    });
                    vm.regionalLeaderProvince = regionalLeaderProvince;
                }

                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);

                this.filter.page.page = 1;
                this.filter.page.size = 1000000;

                var barTitleText = 'Кўчмас мулк';
                if (this.filter.objectType==='AutoAndFitment') {
                    barTitleText = 'Авто ва Асбоб-ускуналар';
                }

                var barTitle = barTitleText;
                this.$eventBus.$emit('refreshHorizontalBarChart', {barTitle: barTitle});
                this.$eventBus.$emit('refreshMixedBarChart', {barTitle: barTitle});

                var barTitle2 = barTitleText + ' ойлар буйича';
                this.$eventBus.$emit('refreshBarChartMonth', {barTitle: barTitle2});

                if (this.filter.startDate != null && this.filter.endDate != null) {
                    barTitle = barTitleText + ' (' + formatDateText(this.filter.startDate) + ' дан  ' + formatDateText(this.filter.endDate) + ' гача)';
                    this.$eventBus.$emit('refreshHorizontalBarChart', {barTitle: barTitle});
                    this.$eventBus.$emit('refreshMixedBarChart', {barTitle: barTitle});

                    barTitle2 = barTitleText + ' ойлар буйича(' + formatDateText(this.filter.startDate) + ' дан  ' + formatDateText(this.filter.endDate) + ' гача)';
                    this.$eventBus.$emit('refreshBarChartMonth', {barTitle: barTitle2});
                }

                if (this.filter.objectType==='AutoAndFitment') {
                    this.loading = true;
                    this.$http.post('legal/list', this.filter)
                        .then(res => {
                            // console.log(res);
                            this.results = res.data.data;
                            this.getTotalDataConfig();
                            this.renderingData(this.results);
                            this.loading = false;
                        }, err => {
                            console.log(err);
                            this.loading = false;
                        });
                } else {
                    this.initListRealEstate();
                }
            },
            initListRealEstate() {
                this.loading = true;
                this.$http.post('legal/building/list', this.filter)
                    .then(res => {
                        this.realEstateResults = res.data.data;
                        // console.log("realEstateResults = ");
                        // console.log(this.realEstateResults);
                        this.getTotalDataConfig();
                        this.renderingData(this.realEstateResults);
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            renderingData(results){
                // console.log("results = ");
                // console.log(results);
                for (var i = 0; i < results.length; i++) {
                    // console.log(this.results[i].contractAmount);
                    const contractAmount = parseFloat(results[i].totalAmountQQS);
                    // console.log(contractAmount);
                    const paid = parseFloat(results[i].paid);
                    const unpaid = (contractAmount -  paid);//parseFloat(results[i].debtor);
                    var dt = new Date(results[i].confirmedDate);
                    const month = (dt.getMonth());
                    // document.write("getMonth() : " + dt.getMonth() );
                    const provinceDto = results[i].provinceDto;
                    const regionDto = results[i].regionDto;
                    const organizationType = results[i].organizationType;
                    const evlGoalType = results[i].evlGoalType;

                    // console.log("getMonth() : " + (dt.getMonth() + 1));
                    if (organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION') {
                        this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.contractAmount += contractAmount;
                        this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.paid += paid;
                        this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.unpaid += unpaid;
                        this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.count++;

                        //By Province
                        if (provinceDto != null && provinceDto.code != null) {
                            this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.provinces[provinceDto.code + ''].contractAmount += contractAmount;
                            this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.provinces[provinceDto.code + ''].paid += paid;
                            this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.provinces[provinceDto.code + ''].unpaid += unpaid;
                            this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.provinces[provinceDto.code + ''].count++;

                            this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.provinces[provinceDto.code + ''].months[month].contractAmount += contractAmount;
                            this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.provinces[provinceDto.code + ''].months[month].paid += paid;
                            this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.provinces[provinceDto.code + ''].months[month].unpaid += unpaid;
                            this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.provinces[provinceDto.code + ''].months[month].count++;
                        }

                        if (regionDto != null && regionDto.id != null) {
                            // console.log(regionDto);
                            var itemMib = findBy(this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.regions, "id", regionDto.id);
                            if (itemMib!=null){
                                itemMib.contractAmount+=contractAmount;
                                itemMib.paid+=paid;
                                itemMib.unpaid+=unpaid;
                            } else {
                                this.contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.regions.push(
                                    {
                                        id: regionDto.id,
                                        name: regionDto.name,
                                        contractAmount: contractAmount,
                                        paid: paid,
                                        unpaid: unpaid
                                    }
                                );
                            }
                        }
                    } else if (organizationType === 'CUSTOMS_ADMINISTRATION') {
                        this.contractAmountTotal.CUSTOMS_ADMINISTRATION.contractAmount += contractAmount;
                        this.contractAmountTotal.CUSTOMS_ADMINISTRATION.paid += paid;
                        this.contractAmountTotal.CUSTOMS_ADMINISTRATION.unpaid += unpaid;
                        this.contractAmountTotal.CUSTOMS_ADMINISTRATION.count++;

                        //By Province
                        if (provinceDto != null && provinceDto.code != null) {
                            this.contractAmountTotal.CUSTOMS_ADMINISTRATION.provinces[provinceDto.code + ''].contractAmount += contractAmount;
                            this.contractAmountTotal.CUSTOMS_ADMINISTRATION.provinces[provinceDto.code + ''].paid += paid;
                            this.contractAmountTotal.CUSTOMS_ADMINISTRATION.provinces[provinceDto.code + ''].unpaid += unpaid;
                            this.contractAmountTotal.CUSTOMS_ADMINISTRATION.provinces[provinceDto.code + ''].count++;

                            this.contractAmountTotal.CUSTOMS_ADMINISTRATION.provinces[provinceDto.code + ''].months[month].contractAmount += contractAmount;
                            this.contractAmountTotal.CUSTOMS_ADMINISTRATION.provinces[provinceDto.code + ''].months[month].paid += paid;
                            this.contractAmountTotal.CUSTOMS_ADMINISTRATION.provinces[provinceDto.code + ''].months[month].unpaid += unpaid;
                            this.contractAmountTotal.CUSTOMS_ADMINISTRATION.provinces[provinceDto.code + ''].months[month].count++;
                        }
                        //By Region
                        if (regionDto != null && regionDto.id != null) {
                            // console.log(regionDto);
                            var itemCustom = findBy(this.contractAmountTotal.CUSTOMS_ADMINISTRATION.regions, "id", regionDto.id);
                            if (itemCustom != null) {
                                itemCustom.contractAmount += contractAmount;
                                itemCustom.paid += paid;
                                itemCustom.unpaid += unpaid;
                            } else {
                                this.contractAmountTotal.CUSTOMS_ADMINISTRATION.regions.push(
                                    {
                                        id: regionDto.id,
                                        name: regionDto.name,
                                        contractAmount: contractAmount,
                                        paid: paid,
                                        unpaid: unpaid
                                    }
                                );
                            }
                        }
                    }
                    else if (organizationType === 'OTHER' || organizationType === 'TRAFFIC_ACCIDENTS') {
                        if (evlGoalType === 'Losses' && this.filter.organizationType==='TRAFFIC_ACCIDENTS') {
                            this.contractAmountTotal.TRAFFIC_ACCIDENTS.contractAmount += contractAmount;
                            this.contractAmountTotal.TRAFFIC_ACCIDENTS.paid+= paid;
                            this.contractAmountTotal.TRAFFIC_ACCIDENTS.unpaid+=unpaid;
                            this.contractAmountTotal.TRAFFIC_ACCIDENTS.count++;

                            //By Province
                            if (provinceDto != null && provinceDto.code != null) {
                                // console.log(provinceDto.code);
                                this.contractAmountTotal.TRAFFIC_ACCIDENTS.provinces[provinceDto.code + ''].contractAmount+=contractAmount;
                                this.contractAmountTotal.TRAFFIC_ACCIDENTS.provinces[provinceDto.code + ''].paid+=paid;
                                this.contractAmountTotal.TRAFFIC_ACCIDENTS.provinces[provinceDto.code + ''].unpaid+=unpaid;
                                this.contractAmountTotal.TRAFFIC_ACCIDENTS.provinces[provinceDto.code + ''].count++;

                                this.contractAmountTotal.TRAFFIC_ACCIDENTS.provinces[provinceDto.code + ''].months[month].contractAmount+=contractAmount;
                                this.contractAmountTotal.TRAFFIC_ACCIDENTS.provinces[provinceDto.code + ''].months[month].paid+=paid;
                                this.contractAmountTotal.TRAFFIC_ACCIDENTS.provinces[provinceDto.code + ''].months[month].unpaid+=unpaid;
                                this.contractAmountTotal.TRAFFIC_ACCIDENTS.provinces[provinceDto.code + ''].months[month].count++;
                            }
                            //By Region
                            if (regionDto != null && regionDto.id != null) {
                                // console.log(regionDto);
                                var item_traffic_accidents = findBy(this.contractAmountTotal.TRAFFIC_ACCIDENTS.regions, "id", regionDto.id);
                                if (item_traffic_accidents != null) {
                                    item_traffic_accidents.contractAmount+=contractAmount;
                                    item_traffic_accidents.paid+=paid;
                                    item_traffic_accidents.unpaid+=unpaid;
                                } else {
                                    this.contractAmountTotal.TRAFFIC_ACCIDENTS.regions.push(
                                        {
                                            id: regionDto.id,
                                            name: regionDto.name,
                                            contractAmount: contractAmount,
                                            paid: paid,
                                            unpaid: unpaid
                                        }
                                    );
                                }
                            }
                        } else {
                            this.contractAmountTotal.OTHER.contractAmount += contractAmount;
                            this.contractAmountTotal.OTHER.paid += paid;
                            this.contractAmountTotal.OTHER.unpaid += unpaid;
                            this.contractAmountTotal.OTHER.count++;

                            //By Province
                            if (provinceDto != null && provinceDto.code != null) {
                                this.contractAmountTotal.OTHER.provinces[provinceDto.code + ''].contractAmount += contractAmount;
                                this.contractAmountTotal.OTHER.provinces[provinceDto.code + ''].paid += paid;
                                this.contractAmountTotal.OTHER.provinces[provinceDto.code + ''].unpaid += unpaid;
                                this.contractAmountTotal.OTHER.provinces[provinceDto.code + ''].count++;

                                this.contractAmountTotal.OTHER.provinces[provinceDto.code + ''].months[month].contractAmount += contractAmount;
                                this.contractAmountTotal.OTHER.provinces[provinceDto.code + ''].months[month].paid += paid;
                                this.contractAmountTotal.OTHER.provinces[provinceDto.code + ''].months[month].unpaid += unpaid;
                                this.contractAmountTotal.OTHER.provinces[provinceDto.code + ''].months[month].count++;
                            }
                            //By Region
                            if (regionDto != null && regionDto.id != null) {
                                // console.log(regionDto);
                                var itemOther = findBy(this.contractAmountTotal.OTHER.regions, "id", regionDto.id);
                                if (itemOther != null) {
                                    itemOther.contractAmount += contractAmount;
                                    itemOther.paid += paid;
                                    itemOther.unpaid += unpaid;
                                } else {
                                    this.contractAmountTotal.OTHER.regions.push(
                                        {
                                            id: regionDto.id,
                                            name: regionDto.name,
                                            contractAmount: contractAmount,
                                            paid: paid,
                                            unpaid: unpaid
                                        }
                                    );
                                }
                            }
                        }
                    }
                    //by default
                    this.contractAmountTotal.ALL.contractAmount += contractAmount;
                    this.contractAmountTotal.ALL.paid += paid;
                    this.contractAmountTotal.ALL.unpaid += unpaid;
                    this.contractAmountTotal.ALL.count++;

                    //By Month
                    this.contractAmountTotal.ALL.months[month + ''].contractAmount += contractAmount;
                    this.contractAmountTotal.ALL.months[month + ''].paid += paid;
                    this.contractAmountTotal.ALL.months[month + ''].unpaid += unpaid;
                    this.contractAmountTotal.ALL.months[month + ''].count++;

                    //By Province
                    if (provinceDto != null && provinceDto.code != null) {
                        this.contractAmountTotal.ALL.provinces[provinceDto.code + ''].contractAmount += contractAmount;
                        this.contractAmountTotal.ALL.provinces[provinceDto.code + ''].paid += paid;
                        this.contractAmountTotal.ALL.provinces[provinceDto.code + ''].unpaid += unpaid;
                        this.contractAmountTotal.ALL.provinces[provinceDto.code + ''].count++;

                        this.contractAmountTotal.ALL.provinces[provinceDto.code + ''].months[month].contractAmount += contractAmount;
                        this.contractAmountTotal.ALL.provinces[provinceDto.code + ''].months[month].paid += paid;
                        this.contractAmountTotal.ALL.provinces[provinceDto.code + ''].months[month].unpaid += unpaid;
                        this.contractAmountTotal.ALL.provinces[provinceDto.code + ''].months[month].count++;
                    }

                    //By Region
                    if (regionDto != null && regionDto.id != null) {
                        // console.log(regionDto);
                        var itemAll = findBy(this.contractAmountTotal.ALL.regions, "id", regionDto.id);
                        if (itemAll!=null){
                            itemAll.contractAmount+=contractAmount;
                            itemAll.paid+=paid;
                            itemAll.unpaid+=unpaid;
                        } else {
                            this.contractAmountTotal.ALL.regions.push(
                                {
                                    id: regionDto.id,
                                    name: regionDto.name,
                                    contractAmount: contractAmount,
                                    paid: paid,
                                    unpaid: unpaid
                                }
                            );
                        }
                    }
                }

                if (this.filter.province != null) {
                    this.$eventBus.$emit('refreshRegionsBarChart', {
                        barTitle: "Авто ва Асбоб-ускуналар Туманлар буйича",
                        province: this.filter.province,
                        contractAmountTotal: this.contractAmountTotal
                    });
                }
                this.loading = false;
            },
            monthsData(){
                const months = [
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    },
                    {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0
                    }
                ];
                return months;
            },
            getTotalDataConfig: function () {
                this.contractAmountTotal = {
                    BUREAU_OF_COMPULSORY_EXECUTION: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: this.monthsData(),
                        provinces: {
                            'Andijan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Bukhara': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Jizzakh': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Kashkadarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Karakalpakstan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Navaiy': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Namangan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Samarkand': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Sirdarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Surkhandarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'TashkentRegion': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Tashkent': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Fergana': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Khwarazm': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            }
                        },
                        regions: []
                    },
                    CUSTOMS_ADMINISTRATION: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: this.monthsData(),
                        provinces: {
                            'Andijan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Bukhara': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Jizzakh': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Kashkadarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Karakalpakstan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Navaiy': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Namangan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Samarkand': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Sirdarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Surkhandarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'TashkentRegion': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Tashkent': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Fergana': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Khwarazm': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            }
                        },
                        regions: []
                    },
                    OTHER: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: this.monthsData(),
                        provinces: {
                            'Andijan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Bukhara': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Jizzakh': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Kashkadarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Karakalpakstan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Navaiy': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Namangan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Samarkand': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Sirdarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Surkhandarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'TashkentRegion': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Tashkent': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Fergana': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Khwarazm': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            }
                        },
                        regions: []
                    },
                    TRAFFIC_ACCIDENTS: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: this.monthsData(),
                        provinces: {
                            'Andijan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Bukhara': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Jizzakh': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Kashkadarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Karakalpakstan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Navaiy': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Namangan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Samarkand': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Sirdarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Surkhandarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'TashkentRegion': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Tashkent': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Fergana': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Khwarazm': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            }
                        },
                        regions: []
                    },
                    ALL: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        count: 0,
                        months: this.monthsData(),
                        provinces: {
                            'Andijan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Bukhara': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Jizzakh': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Kashkadarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Karakalpakstan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Navaiy': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Namangan': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Samarkand': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Sirdarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Surkhandarya': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'TashkentRegion': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Tashkent': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Fergana': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            },
                            'Khwarazm': {
                                contractAmount: 0,
                                paid: 0,
                                unpaid: 0,
                                count: 0,
                                months: this.monthsData()
                            }
                        },
                        regions: []
                    }
                };
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            getOrganizationType() {
                const vm = this;
                // this.loading = true;
                this.$http.get('/account/organizationType')
                    .then(res => {
                        const initData = res.data;
                        if (!vm.filter.organizationType && initData.data && initData.data.length < initData.total && initData.data.length > 0) {
                            vm.filter.organizationType = initData.data[0].code;
                            vm.organization = initData.data[0].displayName
                        }
                        vm.organizationListValue = initData;
                        this.initList();
                        // vm.loading = false;
                    }, (err) => {
                        console.log(err);
                        // vm.loading = false;
                    });
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });
            },

            updateCheckEvaluationObject: function () {
                if (this.selectedEvaluationObject.length > 1) {
                    this.$delete(this.selectedEvaluationObject, 0);
                }
                this.salePropertyDto.evaluationObjectId = this.selectedEvaluationObject[0];
            },
            updateCheckNumberLot: function () {
                if (this.selectedNumberLot.length > 1) {
                    this.$delete(this.selectedNumberLot, 0);
                }
                this.salePropertyDto.numberLot = this.selectedNumberLot[0];
            },
            saveSalesDay: function () {
                this.loading = true;
                this.$http.post('/sale/property/save/', this.salePropertyDto).then(res => {
                    this.loading = false;
                    if (res.data) {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.building.success'),
                            type: 'success'
                        });
                    }
                }, err => {
                    console.log(err);
                });

            },
            onProvinceGetRegionsChange() {
                let regions = [];
                if (this.filter.province && this.filter.province.id && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.filter.province.id) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
                this.filter.region = null;
                // this.initList();
            },
            onRegionsChange() {
                console.log("onRegionsChange");
                // this.initList();
            },
            onOrganizationTypeChange() {
                let organization = null;
                if (this.filter.organizationType==null || this.filter.organizationType==='') {
                    this.$delete(this.filter, 'organizationType');
                }
                if (this.filter.organizationType && this.organizationListValue.data && this.organizationListValue.data.length > 0) {
                    this.organizationListValue.data.forEach((organizationListValue) => {
                        if (organizationListValue.code === this.filter.organizationType) {
                            organization = organizationListValue.displayName;
                        }
                    });
                }
                this.organization = organization;
                // this.initList();
            },
            sendRequirement: function () {
                console.log(this.evaluationObjectIds);
                this.$http.get('/send/message/file/' + this.evaluationObjectIds.toString())
                    .then(res => {
                        console.log(res.data.data);
                    }, err => {
                        console.log(err);
                    });
            },
            requirementPdf: function () {
                console.log(this.evaluationObjectIds);
                this.$http.get('/requirementReport/pdf/' + this.evaluationObjectIds.toString() + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
                    .then(response => {

                        let blob = new Blob([response.data], {type: 'application/pdf'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Талабнома.pdf';
                        link.click()
                    })
            },
            reportXslx: function () {
                this.$http.post('/getAccountingReportExcel/xls/FITMENT_REPORT_VALUABLE_XLS/',this.filter, {responseType: 'arraybuffer'})
                    .then(res => {
                        let blob = new Blob([res.data], {type: 'application/xlsx'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Xisobot.xlsx';
                        link.click();
                    }, err => {
                        console.log(err);
                    });
            },


        },

        created() {
            var d = new Date();
            var currMonth = d.getMonth();
            var currYear = d.getFullYear();
            this.filter.objectType='AutoAndFitment';
            this.filter.startDate = new Date(currYear, currMonth, 1);
            this.filter.endDate = new Date(currYear, currMonth, d.getDate());

            // this.initList();
            this.getOrganizationType();
        },
    }
</script>
<style>
    .scroll-card-body {
        overflow-x: scroll;
        overflow-y: visible;
    }

    td {
        border-top: 1px solid #dee2e6;
    }

    th, td {
        padding: .5rem;
        /*cursor: col-resize;*/
        white-space: nowrap;
    }

    .tdpaid {
        color: red;
    }

    .tdunpaid {
        background-color: transparent;
    }
</style>

